export default "* Farver\n* Nuancer\n* Årstider\n";